import React, { useState, useRef, useEffect } from 'react';
import { Bell, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../../../assests/css/admin/AdminNotificationBell.css';

const AdminNotificationBell = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([
    // {
    //   id: 1,
    //   title: 'New Student Registration',
    //   message: 'John Doe has registered for Computer Science',
    //   time: '5 minutes ago',
    //   isRead: false,
    //   type: 'info'
    // },
    // {
    //   id: 2,
    //   title: 'Fee Payment Received',
    //   message: 'Payment of PKR 50,000 received from Sarah Ali',
    //   time: '15 minutes ago',
    //   isRead: false,
    //   type: 'success'
    // },
    // {
    //   id: 3,
    //   title: 'Exam Schedule Updated',
    //   message: 'Final exam schedule for Semester 3 has been updated',
    //   time: '1 hour ago',
    //   isRead: false,
    //   type: 'warning'
    // },
    // {
    //   id: 4,
    //   title: 'New Teacher Assigned',
    //   message: 'Dr. Ahmed Khan assigned to Mathematics Department',
    //   time: '2 hours ago',
    //   isRead: true,
    //   type: 'info'
    // },
    // {
    //   id: 5,
    //   title: 'Attendance Alert',
    //   message: 'Low attendance detected in CS-101 class',
    //   time: '3 hours ago',
    //   isRead: true,
    //   type: 'alert'
    // }
  ]);

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const unreadCount = notifications.filter(n => !n.isRead).length;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleBellClick = () => {
    setIsOpen(!isOpen);
  };

  const handleNotificationClick = (notificationId) => {
    setNotifications(prev =>
      prev.map(n =>
        n.id === notificationId ? { ...n, isRead: true } : n
      )
    );
  };

  const handleViewAll = () => {
    setIsOpen(false);
    navigate('/admin/notifications');
  };

  const handleClearAll = () => {
    setNotifications([]);
    setIsOpen(false);
  };

  return (
    <div className="adm-notif-bell" ref={dropdownRef}>
      {/* Bell Icon Button */}
      <button
        className="adm-notif-bell__button"
        onClick={handleBellClick}
        aria-label="Notifications"
      >
        <Bell size={22} />
        {unreadCount > 0 && (
          <span className="adm-notif-bell__badge">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {/* Dropdown Panel */}
      {isOpen && (
        <div className="adm-notif-bell__dropdown">
          {/* Header */}
          <div className="adm-notif-bell__header">
            <div className="adm-notif-bell__header-left">
              <h3 className="adm-notif-bell__title">Notifications</h3>
              {unreadCount > 0 && (
                <span className="adm-notif-bell__count">
                  {unreadCount} new
                </span>
              )}
            </div>
            <button
              className="adm-notif-bell__close"
              onClick={() => setIsOpen(false)}
              aria-label="Close notifications"
            >
              <X size={18} />
            </button>
          </div>

          {/* Notifications List */}
          <div className="adm-notif-bell__list">
            {notifications.length === 0 ? (
              <div className="adm-notif-bell__empty">
                <Bell size={48} />
                <p>No notifications</p>
              </div>
            ) : (
              notifications.map((notification) => (
                <div
                  key={notification.id}
                  className={`adm-notif-bell__item ${
                    !notification.isRead ? 'adm-notif-bell__item--unread' : ''
                  } adm-notif-bell__item--${notification.type}`}
                  onClick={() => handleNotificationClick(notification.id)}
                >
                  <div className="adm-notif-bell__item-indicator" />
                  <div className="adm-notif-bell__item-content">
                    <h4 className="adm-notif-bell__item-title">
                      {notification.title}
                    </h4>
                    <p className="adm-notif-bell__item-message">
                      {notification.message}
                    </p>
                    <span className="adm-notif-bell__item-time">
                      {notification.time}
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Footer */}
          {notifications.length > 0 && (
            <div className="adm-notif-bell__footer">
              <button
                className="adm-notif-bell__footer-btn adm-notif-bell__footer-btn--clear"
                onClick={handleClearAll}
              >
                Clear All
              </button>
              <button
                className="adm-notif-bell__footer-btn adm-notif-bell__footer-btn--view"
                onClick={handleViewAll}
              >
                View All
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminNotificationBell;